import { Injectable } from '@angular/core';
import { BrowserService } from 'projects/shared/services/browser.service';
import { LocalStorageRefService } from 'projects/shared/services/localStorageRef.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LightModeService {
  lightMood = new BehaviorSubject<boolean>(false);
  storage: Storage | null;

  constructor(
    private localStorageRef: LocalStorageRefService,
    private _browserService: BrowserService
  ) {
    this.storage = this.localStorageRef.localStorage;

    const localStorageBr = _browserService.getLocalStorage();
    if (localStorageBr) {
      // Support both keys: 'theme' (new) and 'lightMode' (legacy)
      const theme      = this.storage?.getItem('theme');
      const lightMode  = this.storage?.getItem('lightMode');
      const isLight    = theme === 'light' || (theme === null && lightMode === 'true');

      if (!theme && !lightMode) {
        this.storage?.setItem('lightMode', 'false');
        this.storage?.setItem('theme', 'dark');
      }

      this.lightMood.next(isLight);
    }
  }

  /**
   * Toggle light/dark mode and persist to localStorage.
   * Called externally by NavbarHeaderComponent.applyTheme()
   * but can also be called standalone.
   */
  setMode(light: boolean): void {
    this.lightMood.next(light);
    try {
      this.storage?.setItem('theme', light ? 'light' : 'dark');
      this.storage?.setItem('lightMode', light ? 'true' : 'false');
    } catch { /* SSR or private browsing */ }
  }
}
